import { useQuery } from '@tanstack/react-query';
import { listMyOrgs, type Organization } from './api';

// In MVP each user belongs to exactly one company. We don't expose a switcher
// — when multi-company support arrives, this hook becomes the single source of
// truth for the active org.
export function useCurrentOrg() {
  const q = useQuery<Organization[]>({
    queryKey: ['orgs'],
    queryFn: listMyOrgs,
    staleTime: 30_000,
  });
  const org = q.data && q.data.length > 0 ? q.data[0] : null;
  return { org, isLoading: q.isLoading, isError: q.isError, error: q.error };
}
